<!-- MENU -->
<nav class="navbar navbar-expand-lg bg-dark">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#subMenu" aria-controls="subMenu"
          aria-expanded="false" aria-label="Toggle navigation">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="collapse navbar-collapse" id="subMenu">
    <ul class="navbar-nav">
      <ng-container *ngFor="let t of travelStyleCompl">
        <ng-container *ngIf="t?.title != 'ALL'">
          <li class="nav-item">
            <a class="nav-link d-block d-lg-none d-xl-none"
               data-toggle="collapse"
               data-target="#subMenu"
               aria-controls="subMenu"
               aria-expanded="false"
               aria-label="Toggle navigation"
               [ngClass]="{active: t?.lemaxId == lemaxId}"
               (click)="subMenu(t?.Permalink,t?.lemaxId)">{{ t?.shortName | uppercase }}</a>
            <a class="nav-link d-none d-lg-block d-xl-block"
               [ngClass]="{active: t?.lemaxId == lemaxId}"
               (click)="subMenu(t?.Permalink,t?.lemaxId)">{{ t?.shortName | uppercase }}</a>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</nav>

<!-- SECCION 1 IMG -->
<div class="col-12 p-0">
  <div class="hero-image" [ngStyle]="{'background-image':'url(' + travelStyle?.s1landingCoverPhoto.secure_url + ')'}">
    <div class="hero-text col-12 col-lg-8 col-xl-8">
      <h2 class="text-banner">
        {{ travelStyle?.s1slogan | uppercase }}
      </h2>
      <div class="col-12 mx-auto text-center">
        <ng-container [ngSwitch]="lemaxId">
<!--          <button *ngSwitchCase="7" type="button" (click)="filtrarShop('Group')" class="btn btn-travel"-->
<!--                  style="background-color:#A05AB2"> {{ travelStyle?.s1buttonName | uppercase }} </button>-->
<!--          <button *ngSwitchCase="6" type="button" (click)="filtrarShop(travelStyle?.s1buttonUrl)" class="btn btn-travel"-->
<!--                  style="background-color:#CA5E33"> {{ travelStyle?.s1buttonName | uppercase }} </button>-->
<!--          <button *ngSwitchCase="5" type="button" (click)="filtrarShop(travelStyle?.s1buttonUrl)" class="btn btn-travel"-->
<!--                  style="background-color:#36AC98"> {{ travelStyle?.s1buttonName | uppercase }} </button>-->
          <button *ngSwitchDefault type="button"
                  (click)="filtrarShop(travelStyle?.s1buttonUrl)"
                  class="btn btn-travel"> {{ travelStyle?.s1buttonName | uppercase }} </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- SECCION 2 CONTENIDO -->
<div class="container mb-5 contenido">
  <ng-container *ngIf="lemaxId == 325632541320">
    <div class="row teilor">
      <div class="col-12">
        <h4 class="title"> {{ travelStyle?.s2title }} </h4>
      </div>
    </div>
    <div class="row teilor-img">
      <div class="col-12 col-md-6 col-lg-4 col-xl-4" *ngFor="let icons of travelStyle?.s2icons">
        <div class="row">
          <div class="col-3">
            <img class="img" [lazyLoad]="icons?.image" [alt]="icons.image">
          </div>
          <div class="col-9 pl-0">
            <p class="title-row">
              {{ icons.name }}
            </p>
            <div class="subtitle-inner" [innerHTML]="icons?.description | sanitizeHtml"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="row">
    <div class="col-12 col-lg-7 col-xl-7 mx-auto" *ngIf="lemaxId != 325632541320">
      <p class="text inner" [innerHTML]="travelStyle?.s2text | sanitizeHtml"></p>
    </div>
    <div class="col-12 col-md-6 col-lg-6 col-xl-6 img-text-p">
      <img [lazyLoad]="travelStyle?.s3image?.secure_url" class="img-text" alt="">
    </div>
    <div class="col-12 col-md-6 col-lg-6 col-xl-6 my-auto">
      <p class="text-img inner" [innerHTML]="travelStyle?.s3text | sanitizeHtml"></p>
    </div>
  </div>
</div>


<!-- SECCION 3 PROS -->
<div class="container-fluid carousel-pros" *ngIf="travelStyle?.s4title != ''">
  <div class="row">
    <div class="jumbotron jumbotron-fluid w-100">
      <div class="container">
        <h6 class="title">{{ travelStyle?.s4title }}</h6>
        <div class="row mt-5 row-card d-block d-sm-none d-md-none d-lg-block d-xl-block">
          <div class="card-deck justify-content-md-center">
            <div class="card" *ngFor="let pros of travelStyle?.s4elements | slice:0:3; let i = index">
              <div id="pros{{lemaxId}}{{i+1}}" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators" *ngIf="pros.image.length > 1">
                  <li attr.data-target="#pros{{lemaxId}}{{i+1}}"
                      [attr.data-slide-to]="j"
                      [ngClass]="{'active': j == 0}"
                      *ngFor="let g of pros.image;let j = index"></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active" (panleft)="sliderCarusel('left',lemaxId+i+1,'pros')"
                       (panright)="sliderCarusel('right',lemaxId+i+1,'pros')" [ngClass]="{'active': j == 0}"
                       *ngFor="let g of pros.image;let j = index">
                    <img [lazyLoad]="g?.secure_url" class="card-img-top d-block w-100" [alt]="pros.name">
                  </div>
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title"
                    [ngClass]="{'color-group': lemaxId == 7,'color-travel': lemaxId == 6 }">{{ pros.name }}</h5>
                <p class="card-text">{{ pros.description }}</p>
              </div>
            </div>
          </div>
          <div class="card-deck justify-content-md-center">
            <div class="card" *ngFor="let pros of travelStyle?.s4elements | slice:3:6; let i = index">
              <div id="prosScond{{lemaxId}}{{i+1}}" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators" *ngIf="pros.image.length > 1">
                  <li attr.data-target="#prosScond{{lemaxId}}{{i+1}}"
                      [attr.data-slide-to]="j"
                      [ngClass]="{'active': j == 0}"
                      *ngFor="let g of pros.image;let j = index"></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active" (panleft)="sliderCarusel('left',lemaxId+i+1,'prosScond')"
                       (panright)="sliderCarusel('right',lemaxId+i+1,'prosScond')" [ngClass]="{'active': j == 0}"
                       *ngFor="let g of pros.image;let j = index">
                    <img [lazyLoad]="g?.secure_url" class="card-img-top d-block w-100" alt="...">
                  </div>
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title"
                    [ngClass]="{'color-group': lemaxId == 7,'color-travel': lemaxId == 6 }">{{ pros.name }}</h5>
                <p class="card-text">{{ pros.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5 row-card d-none d-sm-block d-md-block d-lg-none d-xl-none">
          <div class="card-deck justify-content-md-center">
            <div class="card" *ngFor="let pros of travelStyle?.s4elements | slice:0:2; let i = index">
              <div id="pros{{lemaxId}}{{i+1}}" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators" *ngIf="pros.image.length > 1">
                  <li attr.data-target="#pros{{lemaxId}}{{i+1}}"
                      [attr.data-slide-to]="j"
                      [ngClass]="{'active': j == 0}"
                      *ngFor="let g of pros.image;let j = index"></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active" (panleft)="sliderCarusel('left',lemaxId+i+1,'pros')"
                       (panright)="sliderCarusel('right',lemaxId+i+1,'pros')" [ngClass]="{'active': j == 0}"
                       *ngFor="let g of pros.image;let j = index">
                    <img [lazyLoad]="g?.secure_url" class="card-img-top d-block w-100" alt="...">
                  </div>
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title"
                    [ngClass]="{'color-group': lemaxId == 7,'color-travel': lemaxId == 6 }">{{ pros.name }}</h5>
                <p class="card-text">{{ pros.description }}</p>
              </div>
            </div>
          </div>

          <div class="card-deck justify-content-md-center">
            <div class="card" *ngFor="let pros of travelStyle?.s4elements | slice:2:4; let i = index">
              <div id="prosScond{{lemaxId}}{{i+1}}" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators" *ngIf="pros.image.length > 1">
                  <li attr.data-target="#prosScond{{lemaxId}}{{i+1}}"
                      [attr.data-slide-to]="j"
                      [ngClass]="{'active': j == 0}"
                      *ngFor="let g of pros.image;let j = index"></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active" (panleft)="sliderCarusel('left',lemaxId+i+1,'prosScond')"
                       (panright)="sliderCarusel('right',lemaxId+i+1,'prosScond')" [ngClass]="{'active': j == 0}"
                       *ngFor="let g of pros.image;let j = index">
                    <img [lazyLoad]="g?.secure_url" class="card-img-top d-block w-100" alt="...">
                  </div>
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title"
                    [ngClass]="{'color-group': lemaxId == 7,'color-travel': lemaxId == 6 }">{{ pros.name }}</h5>
                <p class="card-text">{{ pros.description }}</p>
              </div>
            </div>
          </div>

          <div class="card-deck justify-content-md-center">
            <div class="card" *ngFor="let pros of travelStyle?.s4elements | slice:4:6; let i = index">
              <div id="prosScond{{lemaxId}}{{i+1}}" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators" *ngIf="pros.image.length > 1">
                  <li attr.data-target="#prosScond{{lemaxId}}{{i+1}}"
                      [attr.data-slide-to]="j"
                      [ngClass]="{'active': j == 0}"
                      *ngFor="let g of pros.image;let j = index"></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active" (panleft)="sliderCarusel('left',lemaxId+i+1,'prosScond')"
                       (panright)="sliderCarusel('right',lemaxId+i+1,'prosScond')" [ngClass]="{'active': j == 0}"
                       *ngFor="let g of pros.image;let j = index">
                    <img [lazyLoad]="g?.secure_url" class="card-img-top d-block w-100" alt="...">
                  </div>
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title"
                    [ngClass]="{'color-group': lemaxId == 7,'color-travel': lemaxId == 6 }">{{ pros.name }}</h5>
                <p class="card-text">{{ pros.description }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


<!-- SECTION THEMES SOLO PARA INDEPENDENT Y GROUP (THEMES) -->
<ng-container *ngIf="(lemaxId == 5 || lemaxId == 7) && travelStyle?.s5themeGrid.length > 0">
  <div class="container themes">
    <div class="row">
      <div class="col-12">
        <h6 class="title">{{ travelStyle?.s5title }}</h6>
        <div [innerHTML]="travelStyle?.s5description | sanitizeHtml"
             [ngClass]="{'description-group': lemaxId == 7,'description-independent': lemaxId == 5}"></div>
      </div>
    </div>
  </div>
  <div class="container top-banner-grid mb-5 d-none d-sm-none d-md-none d-lg-block d-xl-block pl-4 pr-4">
    <mat-grid-list cols="4" rowHeight="200px" gutterSize="15px">
      <mat-grid-tile style="border-radius: 4px;" *ngFor="let t of travelStyle?.s5themeGrid" [colspan]="t?.cols"
                     [rowspan]="t?.rows">
        <a class="a-region"
           [routerLink]="['/','shop','All','0','0','0','0','0','0',(t?.lemaxId),'0','0','Relevance-High-to-Low']"
           (click)="setMenuHome(t.name)">
          <p class="title-region"> {{ t?.name }} </p>
          <img class="card-img-top" [lazyLoad]="t?.coverPhotoHome?.secure_url" [alt]="t?.name">
        </a>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
  <div class="container top-banner-grid mb-3 d-none d-sm-block d-md-block d-lg-none d-xl-none">
    <mat-grid-list cols="2" rowHeight="200px" gutterSize="15px">
      <mat-grid-tile style="border-radius: 4px;" *ngFor="let t of travelStyle?.s5themeGrid" colspan="1" rowspan="1">
        <a class="a-region"
           [routerLink]="['/','shop','All','0','0','0','0','0','0',(t?.lemaxId),'0','0','Relevance-High-to-Low']"
           (click)="setMenuHome(t.name)">
          <p class="title-region"> {{ t?.name }} </p>
          <img class="card-img-top" [lazyLoad]="t?.coverPhotoHome?.secure_url" [alt]="t?.name">
        </a>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
  <div class="container top-banner-grid mb-3 d-block d-sm-none d-md-none d-lg-none d-xl-none">
    <mat-grid-list cols="1" rowHeight="200px" gutterSize="15px">
      <mat-grid-tile style="border-radius: 4px;" *ngFor="let t of travelStyle?.s5themeGrid" colspan="1" rowspan="1">
        <a class="a-region"
           [routerLink]="['/','shop','All','0','0','0','0','0','0',(t?.lemaxId),'0','0','Relevance-High-to-Low']"
           (click)="setMenuHome(t.name)">
          <p class="title-region"> {{ t?.name }} </p>
          <img class="card-img-top" [lazyLoad]="t?.coverPhotoHome?.secure_url" [alt]="t?.name">
        </a>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</ng-container>


<!-- SECTION GROUP -->
<div class="container-fluid section-group" *ngIf="lemaxId == 7">
  <div class="row">
    <div class="col-12 col-lg-8 col-xl-8 pl-0 padding-smart">
      <div class="jumbotron jumbotron-fluid padding-backpacker">
        <div class="container">
          <h6 class="title">{{ travelStyle?.s6title }}</h6>
          <div class="description pl-4 pr-4 mt-4 mb-5" [innerHTML]="travelStyle?.s6description | sanitizeHtml"></div>
          <a mat-raised-button type="button" [name]="travelStyle?.s6buttonName" class="btn btn-travel ml-4 mr-4"
                  style="background-color:#A05AB2" [href]="travelStyle?.s6buttonUrl">
            {{ travelStyle?.s6buttonName }}
          </a>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4 col-xl-4 pl-0 padding-smart">
      <img class="img" [lazyLoad]="travelStyle?.s6image?.secure_url" alt="">
    </div>
  </div>
</div>


<!-- SECCION TRAVEL PASSES -->
<div class="container secciont-travel step-smart-desk" *ngIf="travelStyle?.s6BTitle != ''">
  <div class="row">
    <h6 class="title col-12 ">{{ travelStyle?.s6BTitle }}</h6>
    <div class="container-step mx-auto">
      <ng-container *ngFor="let step of travelStyle?.s6BElements">
        <div class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 step"
             [ngStyle]="{'background-image':'url(' + step.image + ')'}">
          <p class="title"> {{ step.name }} </p>
          <hr class="border-step">
          <p class="description">{{ step.description }}</p>
        </div>
      </ng-container>
    </div>
    <small class="note col-12">{{ travelStyle?.s6BNote }}</small>
  </div>
</div>
<div class="container secciont-travel step-tablet" *ngIf="travelStyle?.s6BTitle != ''">
  <div class="row">
    <h6 class="title col-12 ">{{ travelStyle?.s6BTitle }}</h6>
    <div class="container-step mx-auto">
      <ng-container *ngFor="let step of travelStyle?.s6BElements | slice:0:3">
        <div class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 step"
             [ngStyle]="{'background-image':'url(' + step.image + ')'}">
          <p class="title"> {{ step.name }} </p>
          <hr class="border-step">
          <p class="description">{{ step.description }}</p>
        </div>
      </ng-container>
    </div>
    <!-- <small class="note col-12">{{ travelStyle?.s6BNote }}</small> -->
  </div>
</div>
<div class="container secciont-travel step-tablet" *ngIf="travelStyle?.s6BTitle != ''">
  <div class="row">
    <!-- <h6 class="title col-12 ">{{ travelStyle?.s6BTitle }}</h6> -->
    <div class="container-step mx-auto">
      <ng-container *ngFor="let step of travelStyle?.s6BElements | slice:3:6">
        <div class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 step"
             [ngStyle]="{'background-image':'url(' + step.image + ')'}">
          <p class="title"> {{ step.name }} </p>
          <hr class="border-step">
          <p class="description">{{ step.description }}</p>
        </div>
      </ng-container>
    </div>
    <small class="note col-12">{{ travelStyle?.s6BNote }}</small>
  </div>
</div>


<!-- section group recommended -->
<ng-container
  *ngIf="(travelStyle?.s7title != '' && travelStyle?.s7recommendedForYou.length > 0) && (travelStyle?.lemaxId >= 5 && travelStyle?.lemaxId <= 7) ">
  <div class="container-fluid recommended">
    <div class="row">
      <div class="jumbotron jumbotron-fluid w-100">
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-6 col-xl-6">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 title-left title">
                      {{ travelStyle?.s7title }}
                    </div>
                    <!-- <div class="col-md-7">
                      <mat-divider ></mat-divider>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-6 d-none d-lg-block d-xl-block my-auto more-right">
              <a class="more" [routerLink]="['/','shop','All','0','0','0','0','0','0','0','0','0']">
                {{ home.recommendedText }}
                <img src="assets/img/shared/arrowRight.svg" width="10" alt="">
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div> <!-- row -->
  </div> <!-- container-fluid -->

  <!-- section carousel recommended -->
  <div class="container top-banner d-none d-sm-none d-md-none d-lg-block d-xl-block">
    <div class="row">
      <div id="carouselControlsRecommendedForYou" class="carousel slide w-100" data-ride="carousel"
           data-interval="500000">
        <div class="carousel-inner">
          <div class="carousel-item" [ngClass]="{'active': rfy.active}"
               *ngFor="let rfy of carruselRecomended;let i = index">
            <div class="d-flex bd-highlight">
              <div class="col-lg-3 col-xl-3 p-2 flex-fill bd-highlight" *ngFor="let t of rfy.tour;let j = index">
                <a class="detail-product">
                  <mat-card>
                    <div id="recommended{{t.idCarousel}}" class="carousel slide" data-ride="carousel">
                      <ol class="carousel-indicators">
                        <li attr.data-target="#recommended{{t.idCarousel}}"
                            [attr.data-slide-to]="k"
                            *ngFor="let g of t.Galery | slice:0:3;let k = index"
                            [ngClass]="{'active' : k == 0}">
                        </li>
                      </ol>
                      <div class="carousel-inner">
                        <div class="discount" *ngIf="t.PriceInfo?.Discount != null">
                          SAVE {{ t.PriceInfo?.Discount?.Percent }}%
                        </div>
                        <div class="discount" *ngIf="t.PriceInfo?.SpecialOffer != null">
                          SAVE ${{ t.PriceInfo?.SpecialOffer?.Discount | discountSeparador }}
                        </div>
                        <ng-container *ngIf="t.Galery.length > 0">
                          <div class="carousel-item" *ngFor="let g of t.Galery | slice:0:3; let k = index "
                               [ngClass]="{'active': k == 0}">
                            <a
                              [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                              target="_blank">
                              <img mat-card-image [lazyLoad]="g.ThumbnailUrl" [alt]="t.TourTitle">
                            </a>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="t.Galery.length == 0">
                          <div class="carousel-item active">
                            <a
                              [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                              target="_blank">
                              <img mat-card-image src="assets/img/NoImage.png" style="z-index:100; cursor:pointer"
                                   [alt]="t.TourTitle">
                            </a>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <a
                      [routerLink]="['/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                      target="_blank">
                      <mat-card-content>
                        <mat-card-title class="centrar-vertical">
                          <div [ngSwitch]="t.Style[0]?.lemaxId">
                            <p *ngSwitchCase="6" class="title-travel-pass">
                              {{ t.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchCase="7" class="title-group">
                              {{ t.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchDefault class="title-independent">
                              {{ t.Style[0]?.shortName }}
                            </p>
                          </div>
                          <p class="sub-country">
                            {{ t.TourTitle }}
                          </p>
                          <p class="sub-recommended">
                            {{ t.MainTheme }}
                          </p>
                          <p class="country">
                            {{ t.Countries }}
                            <span *ngIf="t.NumberOfCountries >= 2"> +{{ t?.NumberOfCountries - 1 }} </span>
                            <ng-container *ngIf="t.DurationDD != null && t.DurationHR == null">
                              / {{ t?.DurationDD }} Days
                            </ng-container>
                            <ng-container *ngIf="t.DurationHR != null">
                              / 1 Day
                            </ng-container>
                          </p>
                          <p class="price">
                            From
                            <span class="price-discount"
                                  *ngIf="t.PriceInfo?.Discount != null">${{ t?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-discount"
                                  *ngIf="t.PriceInfo?.SpecialOffer != null">${{ t?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-total"
                                  *ngIf="t.PriceInfo?.Discount == null && t.PriceInfo?.SpecialOffer == null">${{ t?.PriceInfo?.PriceFormatted | roundDecimal }}
                              USD</span>
                            <span class="price-total"
                                  *ngIf="t.PriceInfo?.Discount != null || t.PriceInfo?.SpecialOffer != null">${{ t?.PriceInfo?.PriceFormatted }}
                              USD</span>
                          </p>
                          <!-- AUN NO SE PROGRAMARA ESTA SECCION -->
                          <!-- <p class="starts">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            199 reviews
                          </p> -->
                        </mat-card-title>
                      </mat-card-content>
                    </a>
                  </mat-card>
                </a>
              </div>
            </div>
          </div>
        </div>
        <a *ngIf="recommendedBoolean" class="carousel-control-prev circle" style="margin-left:6px;"
           (click)="indicatorRecommended('back',carruselRecomended)" href="javascript:void(0)" role="button">
          <img src="assets/img/shared/flechaLeft.svg" alt="">
        </a>
        <a *ngIf="carruselRecomended.length > 1" class="carousel-control-next circle" style="margin-right:6px;"
           (click)="indicatorRecommended('next',carruselRecomended)" href="javascript:void(0)" role="button">
          <img src="assets/img/shared/flechaRigth.svg" alt="">
        </a>
      </div>
    </div>
  </div>
  <div class="container top-banner d-none d-sm-none d-md-block d-lg-none d-xl-none">
    <div class="row">
      <div id="carouselControlsRecommendedForYouTablet" class="carousel slide w-100" data-ride="carousel"
           data-interval="500000">
        <div class="carousel-inner">
          <div class="carousel-item" [ngClass]="{'active': rfy.active}"
               *ngFor="let rfy of carruselRecomended3;let i = index">
            <div class="d-flex bd-highlight">
              <div class="col-md-4 p-2 flex-fill bd-highlight" *ngFor="let t of rfy.tour;let j = index">
                <a class="detail-product">
                  <mat-card>
                    <div class="carousel slide" data-ride="carousel" id="recommendedTablet{{t.idCarousel}}">
                      <ol class="carousel-indicators">
                        <li attr.data-target="#recommendedTablet{{t.idCarousel}}"
                            [attr.data-slide-to]="k"
                            *ngFor="let g of t.Galery | slice:0:3;let k = index"
                            [ngClass]="{'active' : k == 0}">
                        </li>
                      </ol>
                      <div class="carousel-inner">
                        <div class="discount" *ngIf="t.PriceInfo?.Discount != null">
                          SAVE {{ t.PriceInfo?.Discount?.Percent }}%
                        </div>
                        <div class="discount" *ngIf="t.PriceInfo?.SpecialOffer != null">
                          SAVE ${{ t.PriceInfo?.SpecialOffer?.Discount | discountSeparador }}
                        </div>
                        <ng-container *ngIf="t.Galery.length > 0">
                          <div class="carousel-item" (panleft)="sliderCarusel('left',t.idCarousel,'recommendedTablet')"
                               (panright)="sliderCarusel('right',t.idCarousel,'recommendedTablet')"
                               *ngFor="let g of t.Galery | slice:0:3; let k = index" [ngClass]="{'active': k == 0}">
                            <a
                              [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                              target="_blank">
                              <img mat-card-image [lazyLoad]="g.ThumbnailUrl" [alt]="t.TourTitle">
                            </a>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="t.Galery.length == 0">
                          <div class="carousel-item active">
                            <a
                              [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                              target="_blank">
                              <img mat-card-image src="assets/img/NoImage.png">
                            </a>
                          </div>
                        </ng-container>
                      </div>
                      <!-- <a class="carousel-control-prev" href="#recommendedTablet{{t.idCarousel}}" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                      </a>
                      <a class="carousel-control-next" href="#recommendedTablet{{t.idCarousel}}" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                      </a> -->
                    </div>
                    <a
                      [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                      target="_blank">
                      <mat-card-content>
                        <mat-card-title class="centrar-vertical">
                          <div [ngSwitch]="t.Style[0]?.lemaxId">
                            <p *ngSwitchCase="6" class="title-travel-pass">
                              {{ t.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchCase="7" class="title-group">
                              {{ t.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchDefault class="title-independent">
                              {{ t.Style[0]?.shortName }}
                            </p>
                          </div>
                          <p class="sub-country">
                            {{ t.TourTitle }}
                          </p>
                          <p class="sub-recommended">
                            {{ t.MainTheme }}
                          </p>
                          <p class="country">
                            {{ t.Countries }}
                            <span *ngIf="t.NumberOfCountries >= 2"> +{{ t?.NumberOfCountries - 1 }} </span>
                            <ng-container *ngIf="t.DurationDD != null && t.DurationHR == null">
                              / {{ t?.DurationDD }} Days
                            </ng-container>
                            <ng-container *ngIf="t.DurationHR != null">
                              / 1 Day
                            </ng-container>
                          </p>
                          <p class="price">
                            From
                            <span class="price-discount"
                                  *ngIf="t.PriceInfo?.Discount != null">${{ t?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-discount"
                                  *ngIf="t.PriceInfo?.SpecialOffer != null">${{ t?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-total"
                                  *ngIf="t.PriceInfo?.Discount == null && t.PriceInfo?.SpecialOffer == null">${{ t?.PriceInfo?.PriceFormatted | roundDecimal }}
                              USD</span>
                            <span class="price-total"
                                  *ngIf="t.PriceInfo?.Discount != null || t.PriceInfo?.SpecialOffer != null">${{ t?.PriceInfo?.PriceFormatted }}
                              USD</span>
                          </p>
                          <!-- AUN NO SE PROGRAMARA ESTA SECCION -->
                          <!-- <p class="starts">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            199 reviews
                          </p> -->
                        </mat-card-title>
                      </mat-card-content>
                    </a>
                  </mat-card>
                </a>
              </div>
            </div>
          </div>
        </div>
        <a *ngIf="recommendedBoolean" class="carousel-control-prev circle"
           (click)="indicatorRecommended('back',carruselRecomended3)" href="javascript:void(0)" role="button">
          <img src="assets/img/shared/flechaLeft.svg" alt="">
          <!-- <span>
            <mat-icon class="icon-before">arrow_back_ios</mat-icon>
          </span> -->
        </a>
        <a *ngIf="carruselRecomended3.length > 1" class="carousel-control-next circle"
           (click)="indicatorRecommended('next',carruselRecomended3)" href="javascript:void(0)" role="button">
          <img src="assets/img/shared/flechaRigth.svg" alt="">
          <!-- <span>
            <mat-icon class="icon-next">arrow_forward_ios</mat-icon>
          </span> -->
        </a>
      </div>
    </div>
  </div>

  <div class="container top-banner d-none d-sm-block d-md-none d-lg-none d-xl-none">
    <div class="row">
      <div id="carouselControlsRecommendedForYouSmartL" class="carousel slide w-100" data-ride="carousel"
           data-interval="500000">
        <div class="carousel-inner">
          <div class="carousel-item" [ngClass]="{'active': rfy.active}"
               *ngFor="let rfy of carruselRecomended2;let i = index">
            <div class="d-flex bd-highlight">
              <div class="col-sm-6 p-2 flex-fill bd-highlight" *ngFor="let t of rfy.tour;let j = index">
                <!-- [routerLink]="['/','product-detail',(t.TourTitle | urlEspacios), t.TourID, t.Type]" -->
                <a class="detail-product">
                  <mat-card>
                    <div id="recommendedSmartL{{t.idCarousel}}" class="carousel slide" data-ride="carousel">
                      <ol class="carousel-indicators">
                        <li attr.data-target="#recommendedSmartL{{t.idCarousel}}"
                            [attr.data-slide-to]="k"
                            *ngFor="let g of t.Galery | slice:0:3;let k = index"
                            [ngClass]="{'active' : k == 0}">
                        </li>
                      </ol>
                      <div class="carousel-inner">
                        <ng-container *ngIf="t.Galery.length > 0">
                          <div class="discount" *ngIf="t.PriceInfo?.Discount != null">
                            SAVE {{ t.PriceInfo?.Discount?.Percent }}%
                          </div>
                          <div class="discount" *ngIf="t.PriceInfo?.SpecialOffer != null">
                            SAVE ${{ t.PriceInfo?.SpecialOffer?.Discount | discountSeparador }}
                          </div>
                          <div class="carousel-item" (panleft)="sliderCarusel('left',t.idCarousel,'recommendedSmartL')"
                               (panright)="sliderCarusel('right',t.idCarousel,'recommendedSmartL')"
                               *ngFor="let g of t.Galery | slice:0:3; let k = index " [ngClass]="{'active': k == 0}">
                            <a
                              [routerLink]="['/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                              target="_blank">
                              <img mat-card-image [lazyLoad]="g.ThumbnailUrl" [alt]="t.TourTitle">
                            </a>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="t.Galery.length == 0">
                          <div class="carousel-item active">
                            <a
                              [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                              target="_blank">
                              <img mat-card-image src="assets/img/NoImage.png" [alt]="t.TourTitle">
                            </a>
                          </div>
                        </ng-container>
                      </div>
                      <!-- <a class="carousel-control-prev" href="#recommendedSmartL{{t.idCarousel}}" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                      </a>
                      <a class="carousel-control-next" href="#recommendedSmartL{{t.idCarousel}}" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                      </a> -->
                    </div>
                    <a
                      [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                      target="_blank">
                      <mat-card-content>
                        <mat-card-title class="centrar-vertical">
                          <div [ngSwitch]="t.Style[0]?.lemaxId">
                            <p *ngSwitchCase="6" class="title-travel-pass">
                              {{ t.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchCase="7" class="title-group">
                              {{ t.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchDefault class="title-independent">
                              {{ t.Style[0]?.shortName }}
                            </p>
                          </div>
                          <p class="sub-country">
                            {{ t.TourTitle }}
                          </p>
                          <p class="sub-recommended">
                            {{ t.MainTheme }}
                          </p>
                          <p class="country">
                            {{ t.Countries }}
                            <span *ngIf="t.NumberOfCountries >= 2"> +{{ t?.NumberOfCountries - 1 }} </span>
                            <ng-container *ngIf="t.DurationDD != null && t.DurationHR == null">
                              / {{ t?.DurationDD }} Days
                            </ng-container>
                            <ng-container *ngIf="t.DurationHR != null">
                              / 1 Day
                            </ng-container>
                          </p>
                          <p class="price">
                            From
                            <span class="price-discount"
                                  *ngIf="t.PriceInfo?.Discount != null">${{ t?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-discount"
                                  *ngIf="t.PriceInfo?.SpecialOffer != null">${{ t?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-total"
                                  *ngIf="t.PriceInfo?.Discount == null && t.PriceInfo?.SpecialOffer == null">${{ t?.PriceInfo?.PriceFormatted | roundDecimal }}
                              USD</span>
                            <span class="price-total"
                                  *ngIf="t.PriceInfo?.Discount != null || t.PriceInfo?.SpecialOffer != null">${{ t?.PriceInfo?.PriceFormatted }}
                              USD</span>
                          </p>
                          <!-- AUN NO SE PROGRAMARA ESTA SECCION -->
                          <!-- <p class="starts">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            199 reviews
                          </p> -->
                        </mat-card-title>
                      </mat-card-content>
                    </a>
                  </mat-card>
                </a>
              </div>
            </div>
          </div>
        </div>
        <a *ngIf="recommendedBoolean" class="carousel-control-prev circle"
           (click)="indicatorRecommended('back',carruselRecomended2)" href="javascript:void(0)" role="button">
          <img src="assets/img/shared/flechaLeft.svg" alt="">
          <!-- <span>
            <mat-icon class="icon-before">arrow_back_ios</mat-icon>
          </span> -->
        </a>
        <a *ngIf="carruselRecomended2.length > 1" class="carousel-control-next circle"
           (click)="indicatorRecommended('next',carruselRecomended2)" href="javascript:void(0)" role="button">
          <img src="assets/img/shared/flechaRigth.svg" alt="">
          <!-- <span>
            <mat-icon class="icon-next">arrow_forward_ios</mat-icon>
          </span> -->
        </a>
      </div>
    </div>
  </div>

  <div class="container top-banner d-block d-sm-none d-md-none d-lg-none d-xl-none">
    <div class="row">
      <div id="carouselControlsRecommendedForYouSmart" class="carousel slide w-100" data-ride="carousel"
           data-interval="500000">
        <div class="carousel-inner">
          <div class="carousel-item" [ngClass]="{'active': rfy.active}"
               *ngFor="let rfy of carruselRecomended1;let i = index">
            <div class="d-flex bd-highlight">
              <div class="col-12 flex-fill bd-highlight" *ngFor="let t of rfy.tour;let j = index">
                <a class="detail-product">
                  <mat-card>
                    <div id="recommendedSmart{{t.idCarousel}}" class="carousel slide" data-ride="carousel">
                      <ol class="carousel-indicators">
                        <li attr.data-target="#recommendedSmart{{t.idCarousel}}"
                            [attr.data-slide-to]="k"
                            *ngFor="let g of t.Galery | slice:0:3;let k = index"
                            [ngClass]="{'active' : k == 0}">
                        </li>
                      </ol>
                      <div class="carousel-inner">
                        <ng-container *ngIf="t.Galery.length > 0">
                          <div class="discount" *ngIf="t.PriceInfo?.Discount != null">
                            SAVE {{ t.PriceInfo?.Discount?.Percent }}%
                          </div>
                          <div class="discount" *ngIf="t.PriceInfo?.SpecialOffer != null">
                            SAVE ${{ t.PriceInfo?.SpecialOffer?.Discount | discountSeparador }}
                          </div>
                          <div class="carousel-item" (panleft)="sliderCarusel('left',t.idCarousel,'recommendedSmart')"
                               (panright)="sliderCarusel('right',t.idCarousel,'recommendedSmart')"
                               *ngFor="let g of t.Galery | slice:0:3; let k = index " [ngClass]="{'active': k == 0}">
                            <a
                              [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                              target="_blank">
                              <img mat-card-image [lazyLoad]="g.ThumbnailUrl" [alt]="t.TourTitle">
                            </a>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="t.Galery.length == 0">
                          <div class="carousel-item active">
                            <a
                              [routerLink]="['/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                              target="_blank">
                              <img mat-card-image src="assets/img/NoImage.png" [alt]="t.TourTitle">
                            </a>
                          </div>
                        </ng-container>
                      </div>
                      <!-- <a class="carousel-control-prev" href="#recommendedSmart{{t.idCarousel}}" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                      </a>
                      <a class="carousel-control-next" href="#recommendedSmart{{t.idCarousel}}" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                      </a> -->
                    </div>
                    <a
                      [routerLink]="['/adventure/',(t.Countries +'-'+ t.Style[0]?.Permalink +'-'+ t.MainTheme) | urlEspacios,t.TourTitle | urlEspacios,t.TourID,t.Type]"
                      target="_blank">
                      <mat-card-content>
                        <mat-card-title class="centrar-vertical">
                          <div [ngSwitch]="t.Style[0]?.lemaxId">
                            <p *ngSwitchCase="6" class="title-travel-pass">
                              {{ t.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchCase="7" class="title-group">
                              {{ t.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchDefault class="title-independent">
                              {{ t.Style[0]?.shortName }}
                            </p>
                          </div>
                          <p class="sub-country">
                            {{ t.TourTitle }}
                          </p>
                          <p class="sub-recommended">
                            {{ t.MainTheme }}
                          </p>
                          <p class="country">
                            {{ t.Countries }}
                            <span *ngIf="t.NumberOfCountries >= 2"> +{{ t?.NumberOfCountries - 1 }} </span>
                            <ng-container *ngIf="t.DurationDD != null && t.DurationHR == null">
                              / {{ t?.DurationDD }} Days
                            </ng-container>
                            <ng-container *ngIf="t.DurationHR != null">
                              / 1 Day
                            </ng-container>
                          </p>
                          <p class="price">
                            From
                            <span class="price-discount"
                                  *ngIf="t.PriceInfo?.Discount != null">${{ t?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-discount"
                                  *ngIf="t.PriceInfo?.SpecialOffer != null">${{ t?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-total"
                                  *ngIf="t.PriceInfo?.Discount == null && t.PriceInfo?.SpecialOffer == null">${{ t?.PriceInfo?.PriceFormatted | roundDecimal }}
                              USD</span>
                            <span class="price-total"
                                  *ngIf="t.PriceInfo?.Discount != null || t.PriceInfo?.SpecialOffer != null">${{ t?.PriceInfo?.PriceFormatted }}
                              USD</span>
                          </p>
                          <!-- AUN NO SE PROGRAMARA ESTA SECCION -->
                          <!-- <p class="starts">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            199 reviews
                          </p> -->
                        </mat-card-title>
                      </mat-card-content>
                    </a>
                  </mat-card>
                </a>
              </div>
            </div>
          </div>
        </div>
        <a *ngIf="recommendedBoolean" class="carousel-control-prev circle"
           (click)="indicatorRecommended('back',carruselRecomended1)" href="javascript:void(0)" role="button">
          <img src="assets/img/shared/flechaLeft.svg" alt="">
          <!-- <span>
            <mat-icon class="icon-before">arrow_back_ios</mat-icon>
          </span> -->
        </a>
        <a *ngIf="carruselRecomended1.length > 1" class="carousel-control-next circle"
           (click)="indicatorRecommended('next',carruselRecomended1)" href="javascript:void(0)" role="button">
          <img src="assets/img/shared/flechaRigth.svg" alt="">
          <!-- <span>
            <mat-icon class="icon-next">arrow_forward_ios</mat-icon>
          </span> -->
        </a>
      </div>
    </div>
  </div>

</ng-container>


<!-- SECCION TRAVEL STYLES -->
<div class="container trip-styles">
  <div class="row">
    <div class="col-12 text-center mt-5 mb-3">
      <mat-divider class="mx-auto divider-section"></mat-divider>
      <h6 class="title">Looking for a different Trip Style?</h6>
      <p class="col-12 col-md-8 col-lg-5 col-xl-5 mx-auto sub-title">We have different trip styles so you can travel the
        way you love
        or we can always make a tailor-made trip perfect for you.</p>
    </div>
  </div>
  <div class="row d-flex justify-content-center">
    <ng-container *ngFor="let ts of travelStyleCompl">
      <ng-container *ngIf="lemaxId != ts.lemaxId && ts.shortName != 'ALL'">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <mat-card [routerLink]="['/',ts.Permalink,ts.lemaxId,'a']">
            <a style="cursor:pointer">
              <img mat-card-image class="trips-styles" [src]=ts?.coverPhoto [alt]="ts?.title">
            </a>
            <mat-card-content style="cursor:pointer">
              <mat-card-title class="text-left">
                <a style="cursor:pointer">
                  <p>
                    {{ ts?.title }} <span class="card-subtitle"> {{ ts?.shortDescription }} </span>
                  </p>
                </a>
              </mat-card-title>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
